import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { NavItem } from "../NavItem";
import { NavLogo } from "../NavLogo";
import CloseIcon from "@material-ui/icons/Close";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpOutlinedIcon from "@material-ui/icons/ArrowDropUpOutlined";
import "./style.css";
import { Subject } from "../Subject";
import { DropdownItem } from "../DropDownItem";
import { SubDropDown } from "../SubDropDown";

function Navbar() {
  const [showDropdown, setShowDropdown] = useState(false);
  const handleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const closeDropAndNav = () => {
    if (showDropdown) {
      setShowDropdown(false);
    }

    closeNav();
  };
  const backSubDropdown = (drop_class) => {
    const menu_bar = document.querySelector(".menu-bar");
    const drop = document.querySelector(drop_class);
    menu_bar.style.marginLeft = "0px";
    drop.style.display = "none";
  };
  const handleSubDropDown = (drop_class) => {
    const menu_bar = document.querySelector(".menu-bar");
    const width = menu_bar.getBoundingClientRect().width;
    const drop = document.querySelector(drop_class);
    menu_bar.style.marginLeft = `-${width}px`;
    drop.style.display = "block";
  };
  const [showNav, setShowNav] = useState(false);
  const body = document.querySelector("body");
  const openNav = () => {
    setShowNav(true);
    body.classList.add("show");
  };
  const closeNav = () => {
    setShowNav(false);
    body.classList.remove("show");
  };

  return (
    <nav className="navigation">
      <div className="nav-center container flex jc-sb ai-c">
        <NavLogo />
        <div
          className={
            showNav
              ? "nav-menu show flex ai-c jc-sb"
              : "nav-menu flex ai-c jc-sb"
          }
        >
          <div className="nav-top flex ai-c jc-sb">
            <NavLogo />
            <div className="close flex ai-c" onClick={closeNav}>
              <CloseIcon />
            </div>
          </div>
          <ul className="nav-list flex jc-sb">
            <NavItem
              list_class="nav-item"
              link="/about-csit"
              classes="link nav-link page-target"
              name="About Bsc.CSIT"
              data="about-csit"
              onClick={closeDropAndNav}
              activeClassName="active"
            />
            <NavItem
              list_class="nav-item dropdown-item"
              link="#"
              activeClassName=""
              classes={
                showDropdown
                  ? "link nav-link dropdown active"
                  : "link nav-link dropdown"
              }
              name="Choose Semester"
              icon={
                showDropdown ? (
                  <ArrowDropUpOutlinedIcon />
                ) : (
                  <ArrowDropDownIcon />
                )
              }
              onClick={handleDropdown}
            >
              {showDropdown && (
                <div className="wrapper">
                  <ul className="menu-bar">
                    <DropdownItem
                      to="#first-sem"
                      onClick={() => handleSubDropDown(".first-sem-drop")}
                      sem={1}
                      sup="st"
                    />
                    <DropdownItem
                      to="#second-sem"
                      onClick={() => handleSubDropDown(".second-sem-drop")}
                      sem={2}
                      sup="nd"
                    />
                    <DropdownItem
                      to="#third-sem"
                      onClick={() => handleSubDropDown(".third-sem-drop")}
                      sem={3}
                      sup="rd"
                    />
                    <DropdownItem
                      to="#fourth-sem"
                      onClick={() => handleSubDropDown(".fourth-sem-drop")}
                      sem={4}
                      sup="th"
                    />
                    <DropdownItem
                      to="#fifth-sem"
                      onClick={() => handleSubDropDown(".fifth-sem-drop")}
                      sem={5}
                      sup="th"
                    />
                    <DropdownItem
                      to="#sixth-sem"
                      onClick={() => handleSubDropDown(".sixth-sem-drop")}
                      sem={6}
                      sup="th"
                    />
                    <DropdownItem
                      to="#seventh-sem"
                      onClick={() => handleSubDropDown(".seventh-sem-drop")}
                      sem={7}
                      sup="th"
                    />
                    <DropdownItem
                      to="#eighth-sem"
                      onClick={() => handleSubDropDown(".eighth-sem-drop")}
                      sem={8}
                      sup="th"
                    />
                    <li>
                      <Link
                        className="dropdown-close link"
                        onClick={handleDropdown}
                      >
                        <div className="icon red">
                          <CloseIcon />
                        </div>
                        Close
                      </Link>
                    </li>
                  </ul>
                  <SubDropDown
                    class_name="first-sem-drop"
                    onClick={() => backSubDropdown(".first-sem-drop")}
                  >
                    <Subject
                      title="Introduction to Information Technology"
                      link="/first-sem/iit"
                      shortcut="IIT"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Mathematics-I"
                      link="/first-sem/math-i"
                      shortcut="M"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Physics"
                      link="/first-sem/phy"
                      shortcut="PHY"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="C Programming"
                      link="/first-sem/c"
                      shortcut="C"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Digital Logic"
                      link="/first-sem/dl"
                      shortcut="DL"
                      onClick={closeDropAndNav}
                    />
                  </SubDropDown>
                  <SubDropDown
                    class_name="second-sem-drop"
                    onClick={() => backSubDropdown(".second-sem-drop")}
                  >
                    <Subject
                      title="Statistics-I"
                      link="/second-sem/stat-i"
                      shortcut="S"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Mathematics-II"
                      link="/second-sem/math-ii"
                      shortcut="M"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Discrete Structure"
                      link="/second-sem/ds"
                      shortcut="DS"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="C++ Programming"
                      link="/second-sem/c++"
                      shortcut="C++"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Microprocesssor"
                      link="/second-sem/mp"
                      shortcut="MP"
                      onClick={closeDropAndNav}
                    />
                  </SubDropDown>
                  <SubDropDown
                    class_name="third-sem-drop"
                    onClick={() => backSubDropdown(".third-sem-drop")}
                  >
                    <Subject
                      title="Statistics-II"
                      link="/third-sem/stat-ii"
                      shortcut="S"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Numerical Method"
                      link="/third-sem/nm"
                      shortcut="NM"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Data Structure & Algorithm"
                      link="/third-sem/dsa"
                      shortcut="DSA"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Computer Architecture"
                      link="/third-sem/ca"
                      shortcut="CA"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Computer Graphics"
                      link="/third-sem/cg"
                      shortcut="CG"
                      onClick={closeDropAndNav}
                    />
                  </SubDropDown>
                  <SubDropDown
                    class_name="fourth-sem-drop"
                    onClick={() => backSubDropdown(".fourth-sem-drop")}
                  >
                    <Subject
                      title="Intoduction to Artificial Intelligence"
                      link="/fourth-sem/ai"
                      shortcut="AI"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Computer Network"
                      link="/fourth-sem/cn"
                      shortcut="NM"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Theory of Computation"
                      link="/fourth-sem/toc"
                      shortcut="TOC"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Operating System"
                      link="/fourth-sem/os"
                      shortcut="OS"
                      onClick={closeDropAndNav}
                    />
                    <Subject
                      title="Database Management System"
                      link="/fourth-sem/dbms"
                      shortcut="DB"
                      onClick={closeDropAndNav}
                    />
                  </SubDropDown>
                  <SubDropDown
                    class_name="fifth-sem-drop"
                    onClick={() => backSubDropdown(".fifth-sem-drop")}
                  ></SubDropDown>
                  <SubDropDown
                    class_name="sixth-sem-drop"
                    onClick={() => backSubDropdown(".sixth-sem-drop")}
                  ></SubDropDown>
                  <SubDropDown
                    class_name="seventh-sem-drop"
                    onClick={() => backSubDropdown(".seventh-sem-drop")}
                  ></SubDropDown>
                  <SubDropDown
                    class_name="eighth-sem-drop"
                    onClick={() => backSubDropdown(".eighth-sem-drop")}
                  ></SubDropDown>
                </div>
              )}
            </NavItem>
            <NavItem
              list_class="nav-item"
              link="/blog"
              name="Blogs"
              data="blog"
              activeClassName="active"
              classes="link nav-link page-target"
              onClick={closeDropAndNav}
            />
            <NavItem
              list_class="nav-item"
              link="/entrance"
              name="Entrance MCQs"
              activeClassName="active"
              data="quiz"
              classes="link nav-link page-target"
              onClick={closeDropAndNav}
            />
          </ul>
          <div className="account-btns-top">
            <Link className="link btn btn-md btn-blue login" to="/login">
              Log in
            </Link>
            <Link className="link signup" to="/sign-up">
              Sign up
            </Link>
          </div>
        </div>
        <div className="account-btns">
          <Link className="link btn btn-blue btn-md login" to="/login">
            Log in
          </Link>
          <Link className="link signup" to="/sign-up">
            Sign up
          </Link>
        </div>
        <div class="hamburger" onClick={openNav}>
          <MenuIcon />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
